function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M4.06348 6.81395V0.333984H9.79512V6.81395H4.06348ZM7.3954 4.85143C8.12749 4.85143 8.72308 4.25947 8.72308 3.53185V1.42233L5.70048 2.31967V4.31798C5.70048 4.62761 5.44704 4.87951 5.13551 4.87951V5.72179C5.91432 5.72179 6.54794 5.09204 6.54794 4.31798V2.94717L7.87562 2.55301V3.53185C7.87562 3.79504 7.6602 4.00915 7.3954 4.00915V4.85143Z",
  fill: "white"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M3.21578 3.84066H0.333008V5.74983H3.21578V3.84066Z",
  fill: "white"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M13.6663 3.84066H10.6423V5.74983H13.6663V3.84066Z",
  fill: "white"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M4.82454 9.6523H6.57596V13.6672H4.82454V9.6523Z",
  fill: "white"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M9.17492 9.6523H7.4235V13.6672H9.17492V9.6523Z",
  fill: "white"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M10.6423 7.65621H3.21578V6.59212H0.333008V13.6673H3.97708V8.81013H10.0223V13.6673H13.6663V6.59212H10.6423V7.65621ZM2.79064 12.0108H1.94318V9.3155H2.79064V12.0108ZM11.2087 9.3155H12.0562V12.0108H11.2087V9.3155Z",
  fill: "white"
});

function SvgIconClubHouse(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconClubHouse);
export default __webpack_public_path__ + "static/media/icon-club-house.52e11e54.svg";
export { ForwardRef as ReactComponent };